export default __webpack_public_path__ + "static/media/Intro.c62dd82b.md";